import NumericInput from './NumericInput'
export default NumericInput
